import { posthog } from './posthog';
import { env } from '../../env';

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!env.POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

const reportedErrors = new WeakSet<object>();

/** For errors an error boundary has already caught. React does not rethrow
 * those, so `capture_exceptions` never sees them. StrictMode and re-renders
 * hand the same error over more than once. */
export function captureError(error: unknown, properties?: Record<string, unknown>) {
  if (!env.POSTHOG_KEY) return;
  if (error && typeof error === 'object') {
    if (reportedErrors.has(error)) return;
    reportedErrors.add(error);
  }
  posthog.captureException(error, properties);
}
